import {
  ACTION_GET_ORG_EXPENSE_REPORTS,
  ACTION_GET_ORG_EXPENSE_REPORTS_SUCCESS,
  ACTION_GET_ORG_EXPENSE_REPORTS_FAILURE,
  ACTION_EMPTY_ORG_EXPENSE_REPORTS,
  ACTION_EDIT_EXPENSE_REPORT,
  ACTION_EDIT_EXPENSE_REPORT_SUCCESS,
  ACTION_EDIT_EXPENSE_REPORT_FAILURE,
} from '../configs/ActionTypes';

const initialState = {
  expenseReports: [] as any[],
  isLoading: false,
  success: null as boolean | null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_ORG_EXPENSE_REPORTS:
    case ACTION_EDIT_EXPENSE_REPORT: {
      return {
        ...state,
        isLoading: true,
        success: null,
      };
    }

    case ACTION_GET_ORG_EXPENSE_REPORTS_SUCCESS: {
      const expenseReports = action.payload?.payload ?? [];

      return {
        ...state,
        expenseReports,
        isLoading: false,
        success: null,
      };
    }

    case ACTION_EDIT_EXPENSE_REPORT_SUCCESS: {
      const updatedReports: any[] = action.payload?.payload ?? [];
      const updatedMap = new Map(
        updatedReports.map((r: any) => [r.id, r]),
      );
      const expenseReports = updatedMap.size > 0
        ? state.expenseReports.map((r: any) =>
            updatedMap.has(r.id) ? { ...r, ...updatedMap.get(r.id) } : r,
          )
        : state.expenseReports;

      return {
        ...state,
        expenseReports,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_GET_ORG_EXPENSE_REPORTS_FAILURE:
    case ACTION_EDIT_EXPENSE_REPORT_FAILURE: {
      return {
        ...state,
        isLoading: false,
        success: false,
      };
    }

    case ACTION_EMPTY_ORG_EXPENSE_REPORTS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
